import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

/**
 * MeteringPointType Partial Translation Cell
 * Translates the meteringPointTypes enum values into relevant values
 */
export const meteringPointTypePartial: Columns<any> = {
  title: 'meter.meteringtype',
  key: 'meteringPointType',
  width: 150,
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.meteringpoint.meteringpointtype.notspecified',
    veproduction: 'enum.meteringpoint.meteringpointtype.veproduction',
    analysis: 'enum.meteringpoint.meteringpointtype.analysis',
    surplusproductiongroup: 'enum.meteringpoint.meteringpointtype.surplusproductiongroup',
    netproduction: 'enum.meteringpoint.meteringpointtype.netproduction',
    supplytogrid: 'enum.meteringpoint.meteringpointtype.supplytogrid',
    consumptionfromgrid: 'enum.meteringpoint.meteringpointtype.consumptionfromgrid',
    wholesaleservices: 'enum.meteringpoint.meteringpointtype.wholesaleservices',
    ownproduction: 'enum.meteringpoint.meteringpointtype.ownproduction',
    netfromgrid: 'enum.meteringpoint.meteringpointtype.netfromgrid',
    nettogrid: 'enum.meteringpoint.meteringpointtype.nettogrid',
    totalconsumption: 'enum.meteringpoint.meteringpointtype.totalconsumption',
    gridlosscorrection: 'enum.meteringpoint.meteringpointtype.gridlosscorrection',
    electricalheating: 'enum.meteringpoint.meteringpointtype.electricalheating',
    internaluse: 'enum.meteringpoint.meteringpointtype.internaluse',
    consumption: 'enum.meteringpoint.meteringpointtype.consumption',
    production: 'enum.meteringpoint.meteringpointtype.production',
    exchange: 'enum.meteringpoint.meteringpointtype.exchange',
    nettoconsumption: 'enum.meteringpoint.meteringpointtype.nettoconsumption',
    otherconsumption: 'enum.meteringpoint.meteringpointtype.otherconsumption',
    otherproduction: 'enum.meteringpoint.meteringpointtype.otherproduction',
    exchangereactiveenergy: 'enum.meteringpoint.meteringpointtype.exchangereactiveenergy',
    effectpayment: 'enum.meteringpoint.meteringpointtype.effectpayment'
  }
};
